import React, { useEffect, useState } from 'react'
import { FaArrowRight } from 'react-icons/fa';
import { FiRefreshCcw } from 'react-icons/fi';
import { ImSpinner2 } from 'react-icons/im';
import * as report from '../../../configurations/crud/reportCrud';
import { useParams } from 'react-router-dom';
import { EOPDRegisteredStatusBg, EOPDRegisteredStatusText, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import { EOPDConfirmedStatusText, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { MdErrorOutline } from 'react-icons/md';
import { useToast } from '../../controls/Toast/ToastService'
import useGlobalLoader from '../../../configurations/useGlobalLoader';


export default function DaillyShortReport({ refresh }) {
    const{start,end} = useGlobalLoader()
    const [registered, setRegistered] = useState([]);
    const [confirmed, setConfirmed] = useState([]);
    const [total, setTotal] = useState({ registered: 0, confirmed: 0 });
    const [loading, setLoading] = useState(true);
    const { centerid } = useParams()
    const toast = useToast()

    useEffect(() => {
        getDailyCenter();
    }, [refresh]);

    const getDailyCenter = () => {
        setLoading(true);
        start()
        report.DailyReport({ centerId: centerid })
            .then(res => {
                const mdata = res.data;
                if (mdata.result.succeeded) {
                    setRegistered(mdata.registered)
                    setConfirmed(mdata.confirmed)
                    let regSum = mdata.registered.reduce((sum, cur) => sum + cur.count, 0)
                    let conSum = mdata.confirmed.reduce((sum, cur) => sum + cur.count, 0)
                    setTotal({ registered: regSum, confirmed: conSum })
                } else {
                    // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                }
                setLoading(false);
                end()
            })
            .catch(errors => {
                // toast.open(errors, <MdErrorOutline />, "danger")
                setLoading(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    };
    return (
        <div className="mb-4">
            <div className="w-full border rounded-3xl shadow-xl bg-sky-50 hover:shadow-2xl border-gray-300 text-xs sm:text-sm p-2.5">
                <div className="flex justify-between items-center flex-wrap gap-2">
                    <div className="flex items-center flex-wrap gap-2 text-xs sm:text-sm">
                        <span className="font-medium">Confirmed</span>
                        <FaArrowRight className="text-blue-600 text-xs mt-0.5" />

                        {loading ?
                            <ImSpinner2 className="animate-spin text-green-600 text-lg" />
                            :
                            <>
                                {confirmed.map((item) =>
                                    <>
                                        <span className={EOPDConfirmedStatusText(item.status)}>
                                            {GetEOPDConfirmedStatusName(item.status)}: <span className='text-black font-semibold'>{item.count}</span>
                                        </span>
                                    </>
                                )}
                                <span>
                                    Total: <span className='font-semibold'>{total.confirmed}</span>
                                </span>
                            </>
                        }
                    </div>

                    <div className="flex items-center flex-wrap gap-2 text-xs sm:text-sm">
                        <span className=" font-medium">Registered</span>
                        <FaArrowRight className="text-blue-600 text-xs mt-0.5" />

                        {loading ?
                            <ImSpinner2 className="animate-spin text-green-600 text-lg" />
                            :
                            <>
                                {registered.map((item) =>
                                    <>
                                        <span className={EOPDRegisteredStatusText(item.status)}>
                                            {GetEOPDRegisterStatusName(item.status)}: <span className='text-black font-semibold'>{item.count}</span>
                                        </span>
                                    </>
                                )}
                                <span>
                                    Total: <span className='font-semibold'>{total.registered}</span>
                                </span>
                            </>
                        }
                    </div>

                    <div>
                        <button
                            title="Refresh"
                            className="p-1 text-green-700 hover:bg-gray-200 hover:rounded-lg active:bg-gray-300 active:rounded-lg"
                            onClick={getDailyCenter}
                        >
                            <FiRefreshCcw />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
